import styled from 'styled-components';

export const ProfileSection = styled.section`
	padding: 1rem;
	p {
		margin: 0;
		font-size: 12px;
		text-align: center;
	}
	p.description {
		text-align: left;
		font-size: 0.875rem;
		margin-bottom: 10px;
	}
`;

export const ProfileAvatar = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	/* gap: 1rem; */

	ion-input {
		margin: 1rem 0 0.35rem;
		text-align: center;
		border-radius: 50px;
		--background: var(--ion-color-light-shade);
		--color: var(--ion-color-primary);
		font-family: var(--title-font);
		font-size: 1.5rem;
		--placeholder-color: var(--ion-color-primary);
		--placeholder-opacity: 0.8;
		--padding-bottom: 10px;
		--padding-end: 10px;
		--padding-start: 10px;
		--padding-top: 10px;
	}

	ion-input .helper-text,
	ion-input .counter {
		color: #373737;
	}
`;

export const ProfileAvatarStack = styled.div`
	display: grid;
	grid-gap: 1.5rem;
	grid-template-columns: repeat(2, 1fr);
	grid-template-rows: repeat(2, 1fr);
	place-items: center;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 100%;
	padding: 0 2rem;
`;

export const ProfileAvatarImg = styled.img`
	width: 7rem;
	height: 7rem;
	aspect-ratio: 1/1;
	border-radius: 50%;
	background-color: var(--ion-color-light-shade);
	border: 5px solid var(--ion-color-light-shade);
`;

export const ProfileSectionTitle = styled.h2`
	/* text-align: center; */
	margin-bottom: 1rem;
	padding-bottom: 1rem;
	border-bottom: 1px solid var(--ion-color-medium);
`;

export const ChecklistItem = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	padding: 0.5rem 0;
	border-bottom: 1px solid var(--ion-color-medium);
	&:last-child {
		border-bottom: none;
	}
`;

export const PermissionList = styled.div`
	display: grid;
	gap: 0.875rem;
`;

export const PermissionCard = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 1rem;
	padding: 1rem;
	border-radius: 18px;
	background: rgba(255, 255, 255, 0.35);
	border: 1px solid rgba(36, 69, 33, 0.12);
	box-shadow: 0 8px 20px rgba(36, 69, 33, 0.08);
`;

export const PermissionInfo = styled.div`
	flex: 1;
	min-width: 0;

	h3 {
		margin: 0 0 0.35rem;
		font-size: 1.1rem;
		font-weight: 600;
		color: var(--ion-color-primary);
	}

	p {
		margin: 0;
		font-size: 0.95rem;
		line-height: 1.35;
		text-align: left;
		color: rgba(36, 69, 33, 0.9);
	}
`;

export const PermissionStatusBadge = styled.div`
	flex-shrink: 0;
	min-width: 6.5rem;
	padding: 0.45rem 0.75rem;
	border-radius: 999px;
	background: var(--ion-color-primary);
	color: #fff;
	text-align: center;
	font-size: 0.85rem;
	font-weight: 600;
	line-height: 1.2;
`;

export const PermissionActions = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 0.5rem;
	flex-shrink: 0;
	min-width: 7.5rem;

	ion-button {
		margin: 0;
		--border-radius: 999px;
		font-size: 0.75rem;
		min-height: 2rem;
	}
`;
